import * as React from "react";
import { forwardRef } from "react";
const SvgColumn = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3 17V7c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 5h13.975c.55 0 1.02.196 1.412.588.392.391.588.862.588 1.412v10c0 .55-.196 1.02-.588 1.413a1.926 1.926 0 0 1-1.412.587H5c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 17Zm1.975 0H8.3V7H4.975v10Zm5.325 0h3.325V7H10.3v10Zm5.325 0h3.325V7h-3.325v10Z" }));
const ForwardRef = forwardRef(SvgColumn);
export default ForwardRef;
